import axiosWithPayloadInterceptor from '../interceptor/axiosWithPayloadInterceptor';
import {
  HTTP_METHODS,
  URLS,
} from '../helpers/constants';
/**
 * Fetch data from APIs related to Cost Maintenance
 *
 * @author slak4170
 */
class CostViewProxy {
  static async fetchCostViewDataRecords(data) {
    const config = {
      url: `${URLS.COST_DATA_URL}/cost-view`,
      method: HTTP_METHODS.POST,
      data,
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data?.data;
  }

  static async fetchCostViewDataDetailRecords(data) {
    const config = {
      url: `${URLS.COST_DATA_URL}/cost-view/detail-record`,
      method: HTTP_METHODS.POST,
      data,
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }
}

export default CostViewProxy;
